import { useSelector } from 'react-redux';
import { getUserPermissions } from 'store/selectors/auth';

type Perms = 'user.view' | 'mail.template.activate' | 'mail.tracking.interrupt';

export default function useCheckPermissions() {
  const permissions = useSelector(getUserPermissions);
  return {
    permissions,
    userCheckPermission: (permissionToCheck: Perms) =>
      permissions.includes(permissionToCheck),
  };
}
